import { render } from "./SlidePoiseFilm.vue?vue&type=template&id=04f435a6&scoped=true"
import script from "./SlidePoiseFilm.vue?vue&type=script&lang=js"
export * from "./SlidePoiseFilm.vue?vue&type=script&lang=js"

import "./SlidePoiseFilm.vue?vue&type=style&index=0&id=04f435a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f435a6"]])

export default __exports__